import React, { useState } from 'react';

const DownArrowIcon = ({
  width = 14,
  height = 8,
  stroke = '#69727C',
  hoverStroke = '#F5F5F5', // white-ish hover color
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <path
        d="M1 1L7 7L13 0.999998"
        stroke={isHovered ? hoverStroke : stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownArrowIcon;
